// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_at-b";
export var colorBlue = "_at-8";
export var colorDot = "_at-0";
export var colorDotLarge = "_at-2";
export var colorDotSmall = "_at-1";
export var colorGreen = "_at-7";
export var colorGrey = "_at-3";
export var colorOrange = "_at-5";
export var colorPink = "_at-a";
export var colorPurple = "_at-9";
export var colorRed = "_at-4";
export var colorYellow = "_at-6";